import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import QOLList from "../pages/Phase-04/QOL/QOLList";
import {
  fetchQolAssessments,
  deleteQolAssessment,
  setCurrentQolAssessment,
} from "../store/slices/qolAssessmentsSlice";

const QOL = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { qolAssessments, isLoading } = useSelector(
    (state) => state.qolAssessments
  );

  useEffect(() => {
    dispatch(fetchQolAssessments());
  }, [dispatch]);

  const handleAdd = () => navigate("/phase04/qol/add");

  const handleEdit = (id) => {
    const assessment = qolAssessments.find((a) => a.id === id);
    dispatch(setCurrentQolAssessment(assessment));
    navigate(`/phase04/qol/edit/${id}`);
  };

  const handleDelete = (id) => {
    dispatch(deleteQolAssessment(id));
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />

        <div className="card">
          <div className="card-body p-0">
            <QOLList
              assessments={qolAssessments}
              isLoading={isLoading}
              onAdd={handleAdd}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default QOL;
